import { resCode } from '@/constants/resCodeConst.ts';
import md5 from 'crypto-js/md5';
import { formateTimestamp } from '@/utils/basicTool';

export class WebFetch {
  private baseURL: string;
  public constructor(config: any) {
    const { baseUrl } = config;
    this.baseURL = baseUrl;
  }
  public post(config) {
    return this.fetch({ ...config, method: 'POST' });
  }
  private fetch(config: any = {}) {
    return new Promise((resolve, reject) => {
      const Appid = String(config.data.appId);
      const Timestamp = String(new Date().getTime());
      const minTimestamp = String(formateTimestamp(Timestamp));
      const Authorization = md5(String(Appid) + String(config.data.keyCode) + String(minTimestamp)).toString();
      window
        .fetch(`${this.baseURL}`, {
          method: config.method,
          body: JSON.stringify(config.data),
          headers: {
            'Content-Type': 'application/json',
            Appid,
            Timestamp,
            Authorization,
          },
        })
        .then((res) => {
          console.log('fetch res: ', res);
          if (res?.ok) {
            return res.json();
          }
          // resolve(res);
        })
        .then((res) => {
          console.log('fetch res2: ', res);
          if (resCode.successCode.includes(res.code)) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          console.log('%cfetch err', 'color: red', err);
          reject(err);
        });
    });
  }
}

export default WebFetch;
